import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, NavLink } from "react-router-dom";
import { put } from '../../utils/api';
import { Form, FormItem, FormInput } from '../common/Form';
import useApiGet from '../../hooks/useApiGet';
//
// Компонент для контроля за экспортом данных в Expodat
// ВНИМАНИЕ: из выдачи выставки удаляются все поля event.expodat кроме поля is_export
//
const Expodat = () => {
	const { t, i18n } = useTranslation();
    const { id } = useParams();
    const lang = i18n.language;
	const method = '/events/' + id;
	const navigate = useNavigate();
	const [ is_export, setIsExport ] = useState(false);
	const [ api_url, setApiUrl ] = useState('https://api.expodat.com/index.php');
	const [ expo_id, setExpoId ] = useState('');
    const [ hall_id, setHallId ] = useState('');
	const [ login, setLogin ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ saveError, setSaveError ] = useState('');
	const [ data ] = useApiGet({ method });
    const [ event, setEvent ] = useState(null);
    const [ isSaving, setIsSaving ] = useState(false);

	useEffect(() => {
		if(data) {
			setEvent(data.event);
            setIsExport(data.event.expodat.is_export);
            setApiUrl(data.event.expodat.api_url ? data.event.expodat.api_url : 'https://api.expodat.com/index.php');
            setExpoId(data.event.expodat.expo_id ? data.event.expodat.expo_id + '' : '');
            setHallId(data.event.expodat.hall_id ? data.event.expodat.hall_id + '' : '');
            setLogin(data.event.expodat.login ?? '');
            setPassword(data.event.expodat.password ?? '');
		}
	}, [ data ]);

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');

        const data = {
            expodat_is_export: is_export,
            expodat_api_url: api_url,
            expodat_expo_id: expo_id,
            expodat_hall_id: hall_id,
            expodat_login: login,
            expodat_password: password,
        };

        const result = await put(method, data);

        if(result.error) {
            setSaveError(result.error);
        } else {
			navigate('/cabinet/eventview/' + result.data.event._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{event ? t('expodat.title_for')+event.name[lang] : t('expodat.title')}</h1>
			{(isSaving || !event) ? <span>{t('common.loading')}</span> :
			<Form
                error={saveError}
                submit={t('common.save')}
                onSubmit={onSubmit}
            >
                <fieldset>
                <legend>{t('expodat.legend')}</legend>
                <FormInput
                    id='is_export'
                    type='checkbox'
                    value={is_export ? 'true' : ''}
                    onChange={() => setIsExport(!is_export)}
                    label={t('expodat.is_export')}
                />
                </fieldset>
                <FormItem>
                    <FormInput
                        id='api_url'
                        type='text'
                        value={api_url}
                        onChange={setApiUrl}
                        placeholder={t('expodat.api_url')}
                        label={t('expodat.api_url')}
                        required={is_export}
                    />
                </FormItem>
                <FormItem>
                    <FormInput
                        id='expo_id'
                        type='text'
                        value={expo_id}
                        onChange={setExpoId}
                        placeholder={t('expodat.expo_id')}
                        label={t('expodat.expo_id')}
                        required={is_export}
                    />
                </FormItem>
                <FormItem>
                    <FormInput
                        id='hall_id'
                        type='text'
                        value={hall_id}
                        onChange={setHallId}
                        placeholder={t('expodat.hall_id')}
                        label={t('expodat.hall_id')}
                        required={is_export}
                    />
                </FormItem>
                <FormItem>
                    <FormInput
                        id='login'
                        type='text'
                        value={login}
                        onChange={setLogin}
                        placeholder={t('expodat.login')}
                        label={t('expodat.login')}
                        required={is_export}
                    />
                </FormItem>
                <FormItem>
                    <FormInput
                        id='password'
                        type='text'
                        value={password}
                        onChange={setPassword}
                        placeholder={t('expodat.password')}
                        label={t('expodat.password')}
                        required={is_export}
                    />
                </FormItem>
			</Form>}
            <p>
                <NavLink to={'/cabinet/eventview/' + id}>{t('common.back')}</NavLink>
            </p>
		</div>
	);
};

export default Expodat;
